

$(function() {
	if (typeof window.feedLocation == 'undefined') {
		window.feedLocation = '';
	}
	if (typeof isMissionPage == 'undefined') {
		window.isMissionPage = false;
	}
	if (typeof isDiscoverPage == 'undefined') {
		window.isDiscoverPage = false;
	}
	if (typeof curUrl == 'undefined') {
		window.curUrl = false;
	}

	$(document).on('click', '#feed-filters input', function(e) {
		// Reload feed based on current filters
		$('.feed-filters-refresh').trigger('click');
	});

	$(document).on('click', '.stream-trigger', function(e) {
		var eventId = $(this).attr('data-id');
		var eventType = $(this).attr('data-type');
		var triggerKey = $(this).attr('data-key');

		if (!$(this).is(':checked')) {
			$.post("/default/ajax?ajax=get_feed_event_stream",
				{ event_id: eventId, event_type: eventType, feed_location: feedLocation, cur_url: curUrl },
				function(stream_data) {
					$('.feed-event-stream[data-key="'+triggerKey+'"]').html(stream_data);

					var animDelay = 100;
					$('.feed-event-stream[data-key="'+triggerKey+'"] .stream.likes-panel').children('.likes-panel-user').each(function() {
						$(this).delay(animDelay).fadeIn(750);

						animDelay = (animDelay + 100);
					});
				});
		}
		else {
			$('.feed-event-stream[data-key="'+triggerKey+'"]').html('');
		}

		$(this).toggleClass('active');

		e.preventDefault();
	});

	$(document).on('click', '.like-trigger-offline', function(e) {
		
		if (feedLocation != 'app') {
			if (curUrl != '') {
				window.location = "/default/signup?redirect="+curUrl;
			}
		}

		e.preventDefault();
	});

	$(document).on('click', '.like-trigger', function(e) {
		var eventId = $(this).attr('data-id');
		var eventType = $(this).attr('data-type');
		var triggerKey = $(this).attr('data-key');

		if (!$(this).hasClass('feed-event-liked')) {
			// update icon
			$(this).children('svg').children('use').attr('xlink:href', '/public/icons/bootstrap-icons.svg#hand-thumbs-up-fill')
			// change number and icon color
			$(this).addClass('feed-event-liked');

			$.post("/default/ajax?ajax=like_event",
				{ event_id: eventId, event_type: eventType, feed_location: feedLocation },
				function(stream_data) {
					var likeTotal = parseInt($('.like-trigger-total[data-key="'+triggerKey+'"]').html());
					likeTotal = (likeTotal + 1);

					$('.like-trigger-total[data-key="'+triggerKey+'"]').html(likeTotal);

					// Open stream
					$('.feed-event-stream[data-key="'+triggerKey+'"]').html(stream_data);

					var animDelay = 100;
					$('.feed-event-stream[data-key="'+triggerKey+'"] .stream.likes-panel').children('.likes-panel-user').each(function() {
						$(this).delay(animDelay).fadeIn(750);

						animDelay = (animDelay + 100);
					});
				});
		}
		else {
			$.post("/default/ajax?ajax=get_feed_event_stream",
				{ event_id: eventId, event_type: eventType, feed_location: feedLocation },
				function(stream_data) {
					$('.feed-event-stream[data-key="'+triggerKey+'"]').html(stream_data);

					var animDelay = 100;
					$('.feed-event-stream[data-key="'+triggerKey+'"] .stream.likes-panel').children('.likes-panel-user').each(function() {
						$(this).delay(animDelay).fadeIn(750);

						animDelay = (animDelay + 100);
					});
				});
		}

		e.preventDefault();
	});

	$(document).on('click', '.comment-trigger', function(e) {
		var eventId = $(this).attr('data-id');
		var eventType = $(this).attr('data-type');
		var triggerKey = $(this).attr('data-key');

		var comment = $('.comment-box-area[data-key="'+triggerKey+'"]').val();

		if (comment.length > 0) { 
			$.post("/default/ajax?ajax=post_event_comment",
				{ event_id: eventId, event_type: eventType, comment: comment, feed_location: feedLocation },
				function(stream_data) {
					$('.feed-event-stream[data-key="'+eventId+'"]').html(stream_data).promise().done(function() {
						if (typeof $('.feed-event-stream[data-key="'+eventId+'"]').children('.stream.feed-event').last().offset() != 'undefined') {
							var scrollTopAmount = $('.feed-event-stream[data-key="'+eventId+'"]').children('.stream.feed-event').last().offset().top - 205;
							$('html, body').animate({scrollTop: scrollTopAmount}, 650);
						}

						$('.feed-event-stream[data-key="'+eventId+'"]').children('.stream.feed-event').last().children('.sfe-bg').show().delay(2500).fadeOut(700);
					});

					var animDelay = 100;
					$('.feed-event-stream[data-key="'+eventId+'"] .stream.likes-panel').children('.likes-panel-user').each(function() {
						$(this).delay(animDelay).fadeIn(750);

						animDelay = (animDelay + 100);
					});

					$('.comment-box-area[data-key="'+triggerKey+'"]').val('');

					var commentTotal = parseInt($('.comment-trigger-total[data-key="'+eventId+'"]').html());
					commentTotal = (commentTotal + 1);

					$('.comment-trigger-total[data-key="'+eventId+'"]').html(commentTotal);
				});
		}

		e.preventDefault();
	});

	$(document).on('click', '.feed-see-more a', function(e) {
		var communityId = $('input#community_id').val();

		var seeMoreLink = $(this);
		var startPos = parseInt(seeMoreLink.attr('data-start')) || 0;
		var limitPos = parseInt(seeMoreLink.attr('data-limit')) || 0;

		// Array of all filters
		var whoFiltersList = {
			me: $('#feed-filters input[data-id="who-me"]').is(':checked'), 
		    following: $('#feed-filters input[data-id="who-following"]').is(':checked'),
		    team: $('#feed-filters input[data-id="who-team"]').is(':checked'),
		    everyone: $('#feed-filters input[data-id="who-everyone"]').is(':checked'),
		    is_mission_page: isMissionPage,
		    is_discover_page: isDiscoverPage
		};

		var whatFiltersList = {
			distance: $('#feed-filters input[data-id="what-distance"]').is(':checked'), 
		    event: $('#feed-filters input[data-id="what-event"]').is(':checked'),
		    award: $('#feed-filters input[data-id="what-award"]').is(':checked')
		};

		$.post("/default/ajax?ajax=get_mission_feed",
			{ who_filters: whoFiltersList, what_filters: whatFiltersList, start: startPos, limit: limitPos, hide: 1, feed_location: feedLocation, community_id: communityId },
			function(feed_data) {
				seeMoreLink.parent('.feed-see-more').remove();

				// Place data (hidden)
				$('#activityfeed-events-wrap .feed-events').append(feed_data);

				// make sure lightbox works on recently added data
				$('a[rel="lightbox"]').swipebox();

				var animDelay = 10; // Should equal or exceed message fade
				var totalEvents = $('#activityfeed-events-wrap .feed-events').children('.feed-event-wrap.hide').length;

				$('#activityfeed-events-wrap .feed-events').children('.feed-event-wrap.hide').each(function(idx) {
					if (idx === totalEvents - 1) {
				        // this is the last one		       
				        $(this).delay(animDelay).slideDown(175, function() {
				        	$(this).removeClass('hide');
				        });
				    }
				    else {
				    	$(this).delay(animDelay).slideDown(175, function() {
				    		$(this).removeClass('hide');
				    	});

						animDelay = (animDelay + 50);
				    }
				});				
			});

		e.preventDefault();
	});

	$(document).on('click', '.feed-filters-refresh', function(e) {
		var communityId = $('input#community_id').val();

		// Array of all filters
		var whoFiltersList = {
			me: $('#feed-filters input[data-id="who-me"]').is(':checked'), 
		    following: $('#feed-filters input[data-id="who-following"]').is(':checked'),
		    team: $('#feed-filters input[data-id="who-team"]').is(':checked'),
		    everyone: $('#feed-filters input[data-id="who-everyone"]').is(':checked'),
		    is_mission_page: isMissionPage,
		    is_discover_page: isDiscoverPage
		};

		var whatFiltersList = {
			distance: $('#feed-filters input[data-id="what-distance"]').is(':checked'), 
		    event: $('#feed-filters input[data-id="what-event"]').is(':checked'),
		    award: $('#feed-filters input[data-id="what-award"]').is(':checked')
		};

		// fade in message
		$('#activityfeed-events-wrap .feed-events-msg').fadeIn(50);
		$('#activityfeed-events-wrap .feed-events-no-results').fadeOut(50);

		// Set height so it doesn't collapse until after they've loaded
		var origHeight = $('#activityfeed-events-wrap').height();
		$('#activityfeed-events-wrap').css('min-height', function() {
			return origHeight
		});

		// Remove data
		$('#activityfeed-events-wrap .feed-events').html('');
		$('#activityfeed-events-wrap .feed-see-more').remove();

		if (Object.values(whatFiltersList).every(item => item === false)) {
			$('#activityfeed-events-wrap .feed-events-msg').fadeOut(50);
			$('#activityfeed-events-wrap .feed-events-no-results').fadeIn(50);
			return;
		}
		$.post("/default/ajax?ajax=get_mission_feed",
			{ who_filters: whoFiltersList, what_filters: whatFiltersList, start: '-'+activityLimit, limit: activityLimit, hide: 1, feed_location: feedLocation, community_id: communityId },
			function(feed_data) {
				// Fade out message and place data (hidden)
				$('#activityfeed-events-wrap .feed-events-msg').fadeOut(350);
				$('#activityfeed-events-wrap .feed-events').html(feed_data);
				$('#activityfeed-events-wrap .feed-see-more').hide();

				var animDelay = 400; // Should equal or exceed message fade
				var totalEvents = $('#activityfeed-events-wrap .feed-events').children('.feed-event-wrap').length;

				$('#activityfeed-events-wrap .feed-events').children('.feed-event-wrap').each(function(idx) {
					if (idx === totalEvents - 1) {
				        // this is the last one			       
				        $(this).delay(animDelay).slideDown(175, function() {
				        	$(this).removeClass('hide');
				        	$('#activityfeed-events-wrap').css('min-height', '');
				        	$('#activityfeed-events-wrap .feed-see-more').show();
				        });
				    }
				    else {
				    	$(this).delay(animDelay).slideDown(175, function() {
				    		$(this).removeClass('hide');
				    	});

						animDelay = (animDelay + 50);
				    }
				});					
			});

		e.preventDefault();
	});
});